import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {useTranslation} from "react-i18next";
import {FormHelperText} from "@mui/material";
import React from "react";
import {CustomStyleFormHelperText, CustomStyleSelect, CustomStyleSelectMenuPaper, CustomStyleSelectRequired} from "./Styles";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description Select
 * @param String id: Identifier for the select (required)
 * @param String name: Name for the select (optional)
 * @param Array<Object> list: List of options: [id:"1", name:"Option 1", id:"2", name:"Option 2"] (required)
 * @param Object inputProps: Defines attributes to apply to the native select (optional)
 * @param String value: Selected option (required)
 * @param String key: Defines the key attribute for the select (optional)
 * @param Boolean disabled: Enable/disable interaction with the select (optional)
 * @param String trans: Text for the label (required)
 * @param Boolean emptyFields: Indicates if the field is empty (optional)
 * @param Boolean required: Indicates if the select is required (optional)
 * @param String color: Defines hexadecimal color for font in each option (optional)
 * @param UseRef ref: Defines reference for the select (optional)
 * @param String keyName: Defines the name attribute to assign to the value attribute in each option in the select (required)
 * @param String helperText: Text for the legend, displayed under the input field (optional)
 * @param Boolean showNoSelectionOption: If showNoSelectionOption===false, no show default option (optional)
 * @param Event onChange: onChange trigger for the select (optional)
 * @param Event onFocus: onFocus trigger for the select (optional)
 * @returns {JSX.Element}
 */
const SELECT_MENU_PROPS = {
    PaperProps: {
        className: "overflow-y-auto maxh-40vh",
        sx: CustomStyleSelectMenuPaper
    }
};

export const CustomSelect = ({ id, name, list,  inputProps, value, selectedKey=false,  disabled, trans,
                               emptyFields, required, color, ref, keyName="name", helperText='',
                               showNoSelectionOption=true, onChange, onFocus, marginBottom = true}) =>{
    const { t } = useTranslation();

    return <>
        <FormControl sx={emptyFields &&  (value === '' || value === null) ? CustomStyleSelectRequired : CustomStyleSelect(marginBottom)}
                     error={emptyFields &&  (value === '' || value === null)}>
            <InputLabel disabled={disabled}>
                {t(trans)}{required === true && ' *'}
            </InputLabel>
            <Select size="small" ref={ref}
                    name={name}
                    value={value ?? ''}
                    key={selectedKey === false? value: selectedKey}
                    required={required}
                    disabled={disabled} onFocus={onFocus}
                    onChange={onChange} inputProps={{...inputProps, id:id}}
                    MenuProps={SELECT_MENU_PROPS}
            >
                {showNoSelectionOption && list.length > 0 && <MenuItem id='mi-cs-no-selection' value={null}>{t("no_selection").toUpperCase()}</MenuItem>}

                {undefined !== list && list.length > 0 ?
                    list?.map((i, index) => {
                        return (
                            <MenuItem id={`mi-cs-selection-${index}`} onClick={(e) =>{
                                e.stopPropagation();
                            }} sx={color && {color:i.color}} key={i.id} value={i[keyName]}>{i?.name?.toUpperCase()}</MenuItem>
                        )
                    })
                    :<MenuItem id='mi-cs-no_options' value={null}>{t("no_options").toUpperCase()}</MenuItem>
                }
            </Select>
            {(emptyFields &&  (value === '' || value === null)) && (
                <FormHelperText id="outlined-weight-helper-text" error={true}
                                sx={CustomStyleFormHelperText(false, marginBottom)}>
                    {t('requiredField')}
                </FormHelperText>
            )}

            {helperText && !emptyFields &&
                <FormHelperText className={"css-k4qjio-MuiFormHelperText-root"} sx={{...CustomStyleFormHelperText(false, marginBottom)}}>{helperText}</FormHelperText>
            }
        </FormControl>
    </>
}
